  export const modulesRoles = [
    {
      type: 'link',
      text: 'Dashboard',
      iconLeft: '<i class="mdi mdi-view-dashboard"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Estadísticas',
          path: { name: 'statistics' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
        },

      ],
    },
    {
      type: 'link',
      text: 'Facturas ',
      iconLeft: '<i class="mdi mdi-folder-table"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Reporte',
          path: { name: 'reportInvoices' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Reporte Facturas']
        },
        {
          type: 'link',
          text: 'Gestión de facturación',
          path: { name: 'alertConfigs' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Gestión Facturación']
        },

        {
          type: 'link',
          text: 'Gestión de clientes',
          path: { name: 'HabeasDataManagement' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
        },
      ],
    },
    {
      type: 'link',
      text: 'Administración',
      iconLeft: '<i class="mdi mdi-cogs"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Clientes',
          path: { name: 'clientsConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Configuración Clientes']
        },
        {
          type: 'link',
          text: 'Usuarios',
          path: { name: 'userConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Configuración Usuarios']
        },
        {
          type: 'link',
          text: 'Configuración Emisor',
          path: { name: 'emisorConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Configuración Emisor']
        },
        {
          type: 'link',
          text: 'Consultar resoluciones de facturación',
          path: { name: 'numerationsConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Consultar Resoluciones']
        },
        {
          type: 'link',
          text: 'Configuración TEF',
          path: { name: 'tefConfig' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          role: ['Administrador', 'AdminI+D', 'Desarrollador'],
          permission: ['Configuración TEF']
        },
        {
          type: 'link',
          text: 'Procesar XMLS FE',
          path: { name: 'loadXML' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Procesar XMLS']
        },
        {
          type: 'link',
          text: 'Descarga XMLS FE',
          path: { name: 'downloadXML' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Descarga XMLS']
        },
        {
          type: 'link',
          text: 'Generación Masiva de NC',
          path: { name: 'massiveCreditNoteProcess' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Generación Masiva de NC']
        },
        {
          type: 'link',
          text: 'Actualizar Estado Transacciones',
          path: { name: 'updateStatusTransactions' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Actualizar Estado Transacciones']
        },
        {
          type: 'link',
          text: 'Eliminar Transacciones',
          path: { name: 'deleteTransactions' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Eliminar Transacciones']
        },

        {
          type: 'link',
          text: 'Configuraciones Hiopos Reports',
          path: { name: 'confHiopos' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Config Hiopos Reports']
        },
        {
          type: 'link',
          text: 'Logs',
          path: { name: 'Logs' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
          permission: ['Logs']
        },
      ],
    },
    {
      type: 'link',
      text: 'Reportes fiscales',
      iconLeft: '<i class="mdi mdi-file-chart"></i>',
      subMenuOptions: [
        {
          type: 'link',
          text: 'Información Exógena Tributaria',
          path: { name: 'exogenaInformation' },
          iconLeft: '<i class="mdi mdi-circle-medium"></i>',
        },
      ],
    },
  ]
